import { store as PesStore } from './pes-router-store';
export const navigateWithRouter = (route, target = document) => {
  const routerEvent = new CustomEvent('pesLinkClick', {
    detail: route,
    bubbles: true,
    composed: true,
    cancelable: true,
  });
  target.dispatchEvent(routerEvent);
};
export const isAppRoutingEnabled = () => {
  return PesStore.get('enableAppRouting');
};
export const getCustomProductCTAs = () => {
  return PesStore.get('productCTAs');
};
export const getCustomAddToCartSettings = () => {
  var _a, _b;
  return (_b = (_a = getCustomProductCTAs()) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.cart;
};
export const getCustomAddToFavoritesSettings = () => {
  var _a, _b;
  return (_b = (_a = getCustomProductCTAs()) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.favorites;
};
export const getIsCustomAddToCartEnabled = () => {
  var _a;
  return !!((_a = getCustomAddToCartSettings()) === null || _a === void 0 ? void 0 : _a.isShown);
};
export const getIsCustomAddToFavoritesEnabled = () => {
  var _a;
  return !!((_a = getCustomAddToFavoritesSettings()) === null || _a === void 0 ? void 0 : _a.isShown);
};
export const getIsProductsInCustomCart = (productIds) => {
  return productIds.every((productId) => {
    var _a, _b;
    return !!((_b = (_a = getCustomAddToCartSettings()) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.includes(productId));
  });
};
export const getIsProductsInCustomFavorites = (productIds) => {
  return productIds.every((productId) => {
    var _a, _b;
    return !!((_b = (_a = getCustomAddToFavoritesSettings()) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.includes(productId));
  });
};
export const getIsCustomPriceEnabled = () => {
  return PesStore.get('showCustomPrice');
};
export const getCustomPrice = () => {
  return PesStore.get('customPrice');
};
export const buildPBSURL = ({ countryCode, languageCode, pageType, pageId }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  let result = window.location.pathname;
  let langAttribute = null;
  const countryRegex = new RegExp(`/${countryCode}/`);
  const languageRegex = new RegExp(`/${languageCode}/`);
  if (!countryRegex.test(window.location.pathname)) {
    langAttribute = (_d = (_c = (_b = (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.getAttribute) === null || _b === void 0 ? void 0 : _b.call(_a, 'lang')) === null || _c === void 0 ? void 0 : _c.split) === null || _d === void 0 ? void 0 : _d.call(_c, '_');
    const [, country] = langAttribute || [];
    result = result.replace(`/${country}/`, `/${countryCode}/`);
  }
  if (!languageRegex.test(window.location.pathname)) {
    langAttribute = langAttribute || ((_h = (_g = (_f = (_e = document.querySelector('body')) === null || _e === void 0 ? void 0 : _e.getAttribute) === null || _f === void 0 ? void 0 : _f.call(_e, 'lang')) === null || _g === void 0 ? void 0 : _g.split) === null || _h === void 0 ? void 0 : _h.call(_g, '_'));
    const [language] = langAttribute || [];
    result = result.replace(`/${language}/`, `/${languageCode}/`);
  }
  return result.replace(new RegExp(`/${countryCode}/${languageCode}/[^/]+/[^/\\?]+`), `/${countryCode}/${languageCode}/${pageType}/${pageId}`);
};
